import { IonButton, IonIcon, IonItem, IonLabel, IonList, IonPopover, IonRadio, IonRadioGroup } from "@ionic/react";
import { t } from "i18next";
import { filterCircle, filterCircleOutline } from "ionicons/icons";
import React, { useState } from "react";
import { useChannelFilter } from "../../../contexts/ChannelFilterContext";

export const ChannelFilter = (props: any) => {
  const [popoverIsOpen, setPopoverIsOpen] = useState<boolean>(false);
  const [event, setEvent] = useState<any>(null);
  const { currentFilter, setCurrentFilter } = useChannelFilter();

  return (
    <>
      <IonButton
        id={"open-channel-filter"}
        fill={"clear"}
        onClick={(e) => {
          setEvent(e);
          setPopoverIsOpen(true);
        }}
      >
        <IonIcon slot={"icon-only"} icon={currentFilter === "" ? filterCircleOutline : filterCircle} />
      </IonButton>
      <IonPopover
        reference={"event"}
        isOpen={popoverIsOpen}
        event={event}
        onIonPopoverDidDismiss={() => {
          setPopoverIsOpen(false);
        }}
      >
        <IonList>
          <IonRadioGroup
            value={currentFilter}
            onIonChange={(e) => {
              setCurrentFilter(e.detail.value);
            }}
          >
            <IonItem>
              <IonLabel>{t("all")}</IonLabel>
              <IonRadio slot={"end"} value={""} />
            </IonItem>

            <IonItem>
              <IonLabel>{t("chats")}</IonLabel>
              <IonRadio slot={"end"} value={"c"} />
            </IonItem>

            <IonItem
              style={{
                "--inner-border-width": 0,
              }}
            >
              <IonLabel>{t("helpdesk")}</IonLabel>
              <IonRadio slot={"end"} value={"h"} />
            </IonItem>
          </IonRadioGroup>
        </IonList>
      </IonPopover>
    </>
  );
};
